import { render, staticRenderFns } from "./CardComprobante.vue?vue&type=template&id=092b8643"
import script from "./CardComprobante.vue?vue&type=script&lang=js"
export * from "./CardComprobante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports